<template>
    <!--
      自实现底部弹出层（不依赖 Vuetify VBottomSheet）。
      Vuetify 3.1.6 的 barrel 注释掉了 VBottomSheet 导出，autoImport 解析不出，
      手动 import 又会撞 vite-plugin-vuetify 的虚拟样式（VBottomSheet.css 不存在）。
      改为 teleport 到 body 的固定定位遮罩，彻底规避该依赖；同时根治原 bug
      （组件未解析时 slot 内容会原地常驻渲染、移动端 Tips 弹窗变成页面内常显）。
    -->
    <Teleport to="body">
        <Transition name="bs-fade">
            <div v-if="isVisible" class="bs-overlay" @click.self="isVisible = false">
                <Transition name="bs-slide" appear>
                    <div class="bs-panel" role="dialog" aria-modal="true">
                        <slot name="content"></slot>
                    </div>
                </Transition>
            </div>
        </Transition>
    </Teleport>
</template>

<script lang="ts" setup>
import { ref, watch, watchEffect } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
});

const isVisible = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

watchEffect(() => {
    isVisible.value = props.modelValue;
});

watch(isVisible, (newValue) => {
    emit('update:modelValue', newValue);
});
</script>

<style scoped lang="scss">
.bs-overlay {
    position: fixed;
    inset: 0;
    z-index: 2400;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
}
.bs-panel {
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

/* 遮罩淡入淡出 */
.bs-fade-enter-active,
.bs-fade-leave-active {
    transition: opacity 0.2s ease;
}
.bs-fade-enter-from,
.bs-fade-leave-to {
    opacity: 0;
}

/* 面板从底部滑入 */
.bs-slide-enter-active,
.bs-slide-leave-active {
    transition: transform 0.25s ease;
}
.bs-slide-enter-from,
.bs-slide-leave-to {
    transform: translateY(100%);
}
</style>
